import { TCurrencyApiDto } from '../api.types'

export const getCurrencyApiRespMock: TCurrencyApiDto[] = [
    {
        code: 'PHP',
        name: 'PHP',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'THB',
        name: 'THB',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'BGN',
        name: 'BGN',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'CZK',
        name: 'CZK',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'NOK',
        name: 'NOK',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'SEK',
        name: 'SEK',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'AUD',
        name: 'AUD',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '10.00000000',
        maximal_amount: '27000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'DKK',
        name: 'DKK',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'HUF',
        name: 'HUF',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'NZD',
        name: 'NZD',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'BRL',
        name: 'BRL',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'BTC_',
        name: '',
        min_confirmations: null,
        is_crypto: true,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'ILS',
        name: 'ILS',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'INR',
        name: 'INR',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'ZAR',
        name: 'ZAR',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'KRW',
        name: 'KRW',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'LTC',
        name: 'litecoin',
        min_confirmations: 6,
        is_crypto: true,
        minimal_amount: '0.02000000',
        maximal_amount: '16500.00000000',
        is_base_of_enabled_pair: true,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: true,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '0.00050000',
        extra_id: null,
    },
    {
        code: 'CAD',
        name: 'CAD',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '10.00000000',
        maximal_amount: '26000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'XMR',
        name: 'monero',
        min_confirmations: 10,
        is_crypto: true,
        minimal_amount: '0.10000000',
        maximal_amount: '7200.00000000',
        is_base_of_enabled_pair: true,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: true,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '0.01500000',
        extra_id: null,
    },
    {
        code: 'USD',
        name: 'USD',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '10.00000000',
        maximal_amount: '20000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'IDR',
        name: 'IDR',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'TRY',
        name: 'TRY',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'MXN',
        name: 'MXN',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'MYR',
        name: 'MYR',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'ETH',
        name: 'ethereum',
        min_confirmations: 12,
        is_crypto: true,
        minimal_amount: '0.01000000',
        maximal_amount: '1600.00000000',
        is_base_of_enabled_pair: true,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: true,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '0.01000000',
        extra_id: null,
    },
    {
        code: 'DOGE',
        name: 'doge',
        min_confirmations: 6,
        is_crypto: true,
        minimal_amount: '100.00000000',
        maximal_amount: '280000000.00000000',
        is_base_of_enabled_pair: true,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: true,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '1.00000000',
        extra_id: null,
    },
    {
        code: 'BTC',
        name: 'bitcoin',
        min_confirmations: 2,
        is_crypto: true,
        minimal_amount: '0.00100000',
        maximal_amount: '100.00000000',
        is_base_of_enabled_pair: true,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: true,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '0.00050000',
        extra_id: null,
    },
    {
        code: 'RNS',
        name: 'renos',
        min_confirmations: 4,
        is_crypto: true,
        minimal_amount: '1.00000000',
        maximal_amount: '10000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'XVG',
        name: 'verge',
        min_confirmations: 6,
        is_crypto: true,
        minimal_amount: '100.00000000',
        maximal_amount: '13000000.00000000',
        is_base_of_enabled_pair: true,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: true,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '1.00000000',
        extra_id: null,
    },
    {
        code: 'RUB',
        name: 'RUB',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '700.00000000',
        maximal_amount: '1500000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'BDG',
        name: 'BitDegree',
        min_confirmations: 12,
        is_crypto: true,
        minimal_amount: '150.00000000',
        maximal_amount: '20000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '75.00000000',
        extra_id: null,
    },
    {
        code: 'EOS',
        name: 'EOS',
        min_confirmations: 12,
        is_crypto: true,
        minimal_amount: '2.00000000',
        maximal_amount: '200.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.35000000',
        extra_id: null,
    },
    {
        code: 'GNT',
        name: 'Golem',
        min_confirmations: 12,
        is_crypto: true,
        minimal_amount: '10.00000000',
        maximal_amount: '15000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'DASH',
        name: 'dash',
        min_confirmations: 2,
        is_crypto: true,
        minimal_amount: '0.05000000',
        maximal_amount: '10000.00000000',
        is_base_of_enabled_pair: true,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: true,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '0.00050000',
        extra_id: null,
    },
    {
        code: 'NANO',
        name: 'nano',
        min_confirmations: 1,
        is_crypto: true,
        minimal_amount: '0.01000000',
        maximal_amount: '300.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.10000000',
        extra_id: null,
    },
    {
        code: 'NEO',
        name: 'neo',
        min_confirmations: 10,
        is_crypto: true,
        minimal_amount: '1.00000000',
        maximal_amount: '150.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00200000',
        extra_id: null,
    },
    {
        code: 'OMG',
        name: 'OmiseGo',
        min_confirmations: 12,
        is_crypto: true,
        minimal_amount: '2.00000000',
        maximal_amount: '50000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.45000000',
        extra_id: null,
    },
    {
        code: 'USDT',
        name: 'tether',
        min_confirmations: 6,
        is_crypto: true,
        minimal_amount: '10.00000000',
        maximal_amount: '50000.00000000',
        is_base_of_enabled_pair: true,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: true,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '10.00000000',
        extra_id: null,
    },
    {
        code: 'ZEC',
        name: 'zcash',
        min_confirmations: 2,
        is_crypto: true,
        minimal_amount: '0.01000000',
        maximal_amount: '6400.00000000',
        is_base_of_enabled_pair: true,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: true,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '0.00200000',
        extra_id: null,
    },
    {
        code: 'EUR',
        name: 'EUR',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '10.00000000',
        maximal_amount: '20000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'GBP',
        name: 'GBP',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '10.00000000',
        maximal_amount: '20000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'JPY',
        name: 'JPY',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '1000.00000000',
        maximal_amount: '7000000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'RON',
        name: 'RON',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'PLN',
        name: 'PLN',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'HRK',
        name: 'HRK',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'CHF',
        name: 'CHF',
        min_confirmations: null,
        is_crypto: false,
        minimal_amount: '0.01000000',
        maximal_amount: '1.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'BCH',
        name: 'bitcoin-cash',
        min_confirmations: 6,
        is_crypto: true,
        minimal_amount: '0.00500000',
        maximal_amount: '3500.00000000',
        is_base_of_enabled_pair: true,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: true,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '0.00250000',
        extra_id: null,
    },
    {
        code: 'BIX',
        name: 'Bibox Token',
        min_confirmations: 12,
        is_crypto: true,
        minimal_amount: '5.00000000',
        maximal_amount: '350000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '15.00000000',
        extra_id: null,
    },
    {
        code: 'XLM',
        name: 'stellar',
        min_confirmations: 0,
        is_crypto: true,
        minimal_amount: '5.00000000',
        maximal_amount: '525000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '1.00000000',
        extra_id: 'memo',
    },
    {
        code: 'BNB',
        name: 'Binance Coin',
        min_confirmations: 12,
        is_crypto: true,
        minimal_amount: '0.50000000',
        maximal_amount: '200.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.30000000',
        extra_id: null,
    },
    {
        code: 'BNT',
        name: 'Bancor',
        min_confirmations: 12,
        is_crypto: true,
        minimal_amount: '1.50000000',
        maximal_amount: '20000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '3.00000000',
        extra_id: null,
    },
    {
        code: 'COB',
        name: 'Cobinhood',
        min_confirmations: 12,
        is_crypto: true,
        minimal_amount: '80.00000000',
        maximal_amount: '32500.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '55.00000000',
        extra_id: null,
    },
    {
        code: 'COSS',
        name: 'COSS',
        min_confirmations: 12,
        is_crypto: true,
        minimal_amount: '35.00000000',
        maximal_amount: '13700.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '25.00000000',
        extra_id: null,
    },
    {
        code: 'HT',
        name: 'Huobi Token',
        min_confirmations: 12,
        is_crypto: true,
        minimal_amount: '2.00000000',
        maximal_amount: '95000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '1.00000000',
        extra_id: null,
    },
    {
        code: 'KCS',
        name: 'KuCoin Shares',
        min_confirmations: 12,
        is_crypto: true,
        minimal_amount: '2.00000000',
        maximal_amount: '450000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '1.20000000',
        extra_id: null,
    },
    {
        code: 'KNC',
        name: 'KyberNetwork',
        min_confirmations: 12,
        is_crypto: true,
        minimal_amount: '5.00000000',
        maximal_amount: '95000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '2.70000000',
        extra_id: null,
    },
    {
        code: 'BMH',
        name: 'BlockMesh',
        min_confirmations: 12,
        is_crypto: true,
        minimal_amount: '1200.00000000',
        maximal_amount: '200000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '600.00000000',
        extra_id: null,
    },
    {
        code: 'QTM',
        name: 'Qtum',
        min_confirmations: 12,
        is_crypto: true,
        minimal_amount: '10.00000000',
        maximal_amount: '30000.00000000',
        is_base_of_enabled_pair: false,
        is_quote_of_enabled_pair: false,
        has_enabled_pairs: false,
        is_base_of_enabled_pair_for_test: false,
        is_quote_of_enabled_pair_for_test: false,
        has_enabled_pairs_for_test: false,
        withdrawal_fee: '0.00000000',
        extra_id: null,
    },
    {
        code: 'XRP',
        name: 'ripple',
        min_confirmations: 0,
        is_crypto: true,
        minimal_amount: '25.00000000',
        maximal_amount: '300000.00000000',
        is_base_of_enabled_pair: true,
        is_quote_of_enabled_pair: true,
        has_enabled_pairs: true,
        is_base_of_enabled_pair_for_test: true,
        is_quote_of_enabled_pair_for_test: true,
        has_enabled_pairs_for_test: true,
        withdrawal_fee: '1.00000000',
        extra_id: 'destination_tag',
    },
]
